(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonials-section')) {
    customElements.define(
      'testimonials-section',
      class TestimonialsSection extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-testimonials-dialog]');
          this.dialogMedia = this.querySelector('[data-testimonials-dialog-media]');
          this.onTriggerClick = this.onTriggerClick.bind(this);
          this.onCloseClick = this.onCloseClick.bind(this);
          this.onDialogClick = this.onDialogClick.bind(this);
          this.onDialogClose = this.onDialogClose.bind(this);
          this.onKeyDown = this.onKeyDown.bind(this);

          this.addEventListener('click', this.onTriggerClick);
          this.querySelectorAll('[data-testimonials-dialog-close]').forEach((button) => {
            button.addEventListener('click', this.onCloseClick);
          });
          if (this.dialog) {
            this.dialog.addEventListener('click', this.onDialogClick);
            this.dialog.addEventListener('close', this.onDialogClose);
          }
          document.addEventListener('keydown', this.onKeyDown);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onTriggerClick);
          this.querySelectorAll('[data-testimonials-dialog-close]').forEach((button) => {
            button.removeEventListener('click', this.onCloseClick);
          });
          if (this.dialog) {
            this.dialog.removeEventListener('click', this.onDialogClick);
            this.dialog.removeEventListener('close', this.onDialogClose);
          }
          document.removeEventListener('keydown', this.onKeyDown);
          this.stopVideo();
          this.closeDialog();
        }

        onTriggerClick(event) {
          const trigger = event.target.closest('[data-testimonials-video-open]');
          if (!trigger || !this.contains(trigger)) return;
          event.preventDefault();
          event.stopPropagation();
          const card = trigger.closest('[data-testimonial-card]');
          const template = card ? card.querySelector('[data-testimonials-video-template]') : null;
          if (!this.dialog || !this.dialogMedia) return;

          this.dialogMedia.replaceChildren();
          if (template) {
            this.dialogMedia.appendChild(template.content.cloneNode(true));
          } else {
            const src = trigger.getAttribute('data-video-src');
            if (!src) return;
            const video = document.createElement('video');
            video.className = 'testimonials-dialog__video';
            video.controls = true;
            video.playsInline = true;
            video.setAttribute('playsinline', '');
            video.setAttribute('controls', '');
            video.preload = 'metadata';
            video.src = src;
            this.dialogMedia.appendChild(video);
          }

          const video = this.dialogMedia.querySelector('video');
          if (video) {
            video.controls = true;
            video.setAttribute('controls', '');
            video.playsInline = true;
          }
          this.mountDialog();
          if (typeof this.dialog.showModal === 'function') {
            this.dialog.showModal();
          } else {
            this.dialog.setAttribute('open', '');
          }
          if (video && typeof video.play === 'function') {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          }
        }

        onCloseClick(event) {
          event.preventDefault();
          this.closeDialog();
        }

        onDialogClick(event) {
          if (event.target === this.dialog) this.closeDialog();
        }

        onKeyDown(event) {
          if (event.key === 'Escape') this.closeDialog();
        }

        onDialogClose() {
          this.stopVideo();
          this.restoreDialog();
        }

        mountDialog() {
          if (!this.dialog || this.dialog.parentElement === document.body) return;
          this.dialogHome = this.dialog.parentNode;
          this.dialogNext = this.dialog.nextSibling;
          document.body.appendChild(this.dialog);
        }

        restoreDialog() {
          if (!this.dialog || !this.dialogHome) return;
          if (this.dialogNext && this.dialogNext.parentNode === this.dialogHome) {
            this.dialogHome.insertBefore(this.dialog, this.dialogNext);
          } else {
            this.dialogHome.appendChild(this.dialog);
          }
          this.dialogHome = null;
          this.dialogNext = null;
        }

        closeDialog() {
          if (!this.dialog) return;
          this.stopVideo();
          if (typeof this.dialog.close === 'function' && this.dialog.open) {
            this.dialog.close();
          } else {
            this.dialog.removeAttribute('open');
            this.restoreDialog();
          }
        }

        stopVideo() {
          if (!this.dialogMedia) return;
          this.dialogMedia.querySelectorAll('video').forEach((video) => {
            video.pause();
            video.removeAttribute('src');
            video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
            if (typeof video.load === 'function') video.load();
          });
          this.dialogMedia.replaceChildren();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
